/**
 * Public auth-page path segments.
 *
 * Single source of truth for which client-side routes are "public" — i.e. login,
 * forgot/reset password, OTP, registration, invalid-invitation. Used by both the
 * route declarations (see `app.routes.ts` → `publicRoutes`) and the auth HTTP
 * interceptor (which needs to know not to redirect to `/login` from these pages).
 *
 * Keep this list in lockstep with `publicRoutes` in `app.routes.ts`.
 */
export const PUBLIC_AUTH_PATH_SEGMENTS = [
  'login', 'auth/login',
  'forgot-password', 'auth/forgot-password',
  'reset-password', 'auth/reset-password',
  'reset-success', 'auth/reset-success',
  'forgot-success', 'auth/forgot-success',
  'totp-setup',
  'verify-otp', 'auth/verify-otp',
  'register',
  'invalid-invitation',
] as const;

// Pre-compile boundary-aware regexes so `/login` does NOT match `/team-loginsessions`.
const PUBLIC_AUTH_PATH_REGEXES = PUBLIC_AUTH_PATH_SEGMENTS.map(
  (seg) => new RegExp(`/${seg}(?:[/?#]|$)`)
);

/**
 * Returns true when the given URL (or `router.url`) points to a public auth page.
 * Matches segment boundaries, not substrings — `/team-loginsessions` is NOT a login page.
 */
export const isPublicAuthPath = (url: string): boolean =>
  PUBLIC_AUTH_PATH_REGEXES.some((re) => re.test(url));
